export enum Events {
   TOKEN_ACQUIRED = 'token_acquired',
   USER_LOGGED_OUT = 'user_logged_out',
}
